import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {LoginService} from '../../../login-service';
import Swal from 'sweetalert2';
import { ImageuploadService } from '../../../Imageupload.service';
@Component({
  selector: 'app-category',
  templateUrl: './users.component.html',
  providers:[LoginService]
 
})
export class UsersComponent implements OnInit {
  usersList: any;
  rowsOnPageSet:any=[]
  pager: {
    totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
    endPage: number; startIndex: number; endIndex: number;
    pages: number[];
  };
  searchWord: string = "";
  pagedItems: any;
  SearchList:any;
  showedituser:boolean=false;
  currentpage: number=1;
  checked=[];
  searchText: any;
  adminUserType:string;
  usersListDetails:any;
  menuName: any;
  menuData: any;
  menuID: any;
  userID: string;
  roleID: string;
  MenuPermissions: string;
  rolesList: any;

  //edituser
  hidetable:boolean=false
  useridofedit:any;
  displaylegaldocs:boolean=false;
  displaycertificates:boolean=false;
  displayportfolio:boolean=false;
  url:any;
    userData:any=[];
    documentsList:any;
    ProfilePic:any;
    skillsList:any;
    filteredskillsList:any=[];
    filtereddocList:any=[];
    workList:any;
    filteredworkList:any=[];
    educationList:any;
    filterededucationList:any=[];
    certificateList:any;
    filteredcertificateList:any=[];
    portfolioList:any;
    filteredportfolioList:any=[];
    usertype:any;
    addnewwork: boolean=false;
    addnewcert:boolean=false;
    initiatordisplay: boolean=true;
    collaboratordisplay: boolean=true;
    workIndustry:any;
    workExperience:any;
    workDescription:any;
  change: string;
  diff: string;
    rowID:any;
    type:string;
    certificateCopy:any;
    certificateTitle:any;
    certificateDesc:any;
    tempUsersList:any;
    collegeName:any;
    educationStartDate:any;
    educationEndDate:any;
    addnewed:boolean=false;
    UsersList:any;
    addnewport: boolean=false;
    portfolio: any;
    portfolioTitle: any;
    portfolioDesc: any;
    reference:any;
    capitalInvestment:any;
    experience:any;
    industry:any;
    city:any;
    district:any;
    country:any;
    legalName:any;
    documentType:any;
    legalDoc:any;
    editdoc:boolean=false;
    filteredSkillsnameList:any=[];
  skillsList2: any;
   filteredskillsList2:any=[];
   filteredskillsList3:any=[];
  imagefile: void;
  IsProfilePic:boolean=false;
  dragAreaClass:any;
  documetpath:any
  documentpath: any;
  filename: string;
  typeoffile: any;
  DocumentName: any;
  certificatename: any;
  portfolioname: any;
  typeofuser: any;
  viewusers:boolean=false;
  selectedUsersListid=[];
  currentPage: number;
  rowsOnPage: number;
  dynamicRows = 10;
  rowCount: any;
  p:any;
  count:any;
savefilter: any;
  constructor(private loginService:LoginService,private router: Router,public imageservice: ImageuploadService) { 
    this.userID=localStorage.getItem("userID");
    this.roleID=localStorage.getItem("roleID");
    this.adminUserType=localStorage.getItem("userTypeid");
    // this.menuData=localStorage.getItem("menuData");
    this.MenuPermissions=localStorage.getItem("MenuPermissions");
    
    this.GetMenusByUserType(3);
  
  }

  ngOnInit(): void {
    
     this.loginService.getselectpage(10)
    this.GetUsers();
    this.GetRoles();
    this.getSkillsregion();
    this.getWorkexperience();
    this.getEducation();
    this.getCertification();
    this.getPortfolio();
    this.getSkills();
    this.getLegaldocuments();
    this.dragAreaClass = "dragarea";
    this.collaboratordisplay=true;
    // this.assigndynamicarray()
  }
 
navigate()
{
  localStorage.setItem('USERCREATEDBY','admin');
  this.router.navigate(['/register']);
}
GetRoles(){
  this.loginService.GetRoles(this.adminUserType).subscribe(data=>
    {  
            this.rolesList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())
if(filteRole.length>0){
  this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);
}
});
}
GetMenusByUserType(userTypeID){
  this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
      {
  
  this.menuData=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
 

  let tempdata=this.menuData;
 
  this.menuData=tempdata.filter(x=>x.menu_name.toString().toLowerCase()==='users');

  if(this.menuData.length>0)
    {
  this.menuName=this.menuData[0]["menu_name"];
  this.menuID=this.menuData[0]["menu_id"];
    }
  

    
  
      });
      }


      selectRow(id,e){
        if(e.target.checked){
         this.selectedUsersListid.push(e.target.id)
        }
        else{
         var index = this.selectedUsersListid.indexOf(e.target.id);
        this.selectedUsersListid.splice(index,1)
        }
      }
      DeleteSelected(){
       if(this.selectedUsersListid.length==0){
         return;
       }
       else{
         event.stopPropagation();
         Swal.fire({
           title: 'Are you sure?',
           text: 'You want to delete the selected rows' ,///
           icon: 'warning',
           showCancelButton: true,
           confirmButtonText: 'Yes',
           cancelButtonText: 'No'
         }).then((result) => {
           if (result.value) {
             this.deleterows(this.selectedUsersListid);//
           } else if (result.dismiss === Swal.DismissReason.cancel) {
       
           }
         })
       }
      }
      deleterows(list){
     for(var i=0;i<list.length;i++){
       this.delete(list[i],'delete');
       this.selectedUsersListid=[];
     }
      }

delete(ID,type) {
  if(type=="delete")
  {
  const json={
    userid:ID,
    param:"d"
  }
  this.loginService.DeleteUser(json).subscribe(data => { 
    if(type=='delete'){
     this.loginService.showSuccess("User Deleted successfully!",'');    
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  }
  })

}

else if(type=="deactivate")
{
  const json={
    userid:ID,
    param:"n"
  }
  
 
  this.loginService.DeleteUser(json).subscribe(data => { 
      this.loginService.showSuccess("User deactivated successfully!",'');
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  
  })
}
else if(type=="activate")
{
  const json={
    userid:ID,
    param:"y"
  }
  
 
  this.loginService.DeleteUser(json).subscribe(data => { 
    
      // Swal.fire("User activated successfully")
      this.loginService.showSuccess("User activated successfully!",'');
    
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  
  })
}
}

DeleteUser(user,type){
  
if(type=="delete")
{
  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to delete this user:' + user.user_name,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(user.id,type);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })

}
else if(type=="deactivate")
{

  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to deactivate this user:' + user.user_name,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(user.id,type);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })
}
else if(type=="activate")
{
  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to activate this user:' + user.user_name,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(user.id,type);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })
}
}
changepagination(page:number){
  this.count=this.rowsOnPage
  console.log(this.rowsOnPage)
  this.loginService.getselectpage(this.rowsOnPage)
  this.loginService.getPager(this.usersListDetails.length, page);
  this.setPage(page)
}
setPage(page: number) {
console.log(page)
   this.p=page;
  this.pager = this.loginService.getPager(this.usersListDetails.length, page);
  this.pagedItems = this.usersListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  this.count=this.pager.pageSize
  this.usersList = this.usersListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  this.currentPage=this.pager.currentPage;
  console.log(this.pager,this.pagedItems)
  // this.changepagination(page);

}

Searchtext(){
  this.usersList = this.usersListDetails;
      let tempCompany = this.usersListDetails.filter(
        (item) => {
          return (
            (item.user_name !== null && item.user_name.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
            (item.user_type !== null && item.user_type.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
            (item.email !== null && item.email.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
          );
        }
  
      );
      this.usersList = tempCompany;
      this.assigndynamicarray(tempCompany)
    if(this.searchText !== ""){
      this.usersListDetails = tempCompany;
      this.setPage(1);
  }else{
      this.usersListDetails = this.savefilter;      
      this.assigndynamicarray(this.usersList)

      this.setPage(1);
  }
     

}
GetUsers()
{
  this.loginService.GetUsers(this.adminUserType).subscribe(data=>
    {  
            this.usersList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
            this.usersListDetails=this.usersList;
            this.savefilter=this.usersListDetails
            console.log(this.usersList)
  this.assigndynamicarray(this.usersList)
  if(this.usersListDetails.length>0){
    this.setPage(1);
  }    
    });
}
assigndynamicarray(userslist)
{
  this.dynamicRows=10
  this.rowsOnPageSet=[];
  this.rowCount = userslist.length;
  console.log(this.rowCount,this.dynamicRows)
  while (this.dynamicRows < this.rowCount) {
    this.rowsOnPageSet.push(this.dynamicRows);
    this.dynamicRows = this.dynamicRows + 10;
    console.log(this.rowsOnPageSet)
  }
  if (!this.rowsOnPageSet.includes(this.rowCount))
    this.rowsOnPageSet.push(this.rowCount);
  if (this.rowsOnPageSet.length === 1) {
    if (this.rowsOnPageSet[0] <= 10)
      this.rowsOnPage = this.rowsOnPageSet[0];
  }
  this.rowsOnPage = this.rowsOnPageSet[0];
}
checkedtrue(u){
  const json={
    userid:u.id
  }
  this.loginService.ReactivateUser(json).subscribe(data => { 
    
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  
  })
}

// view user details
view(details)
{
  this.viewusers=true;
  this.hidetable=true;
  this.showedituser=true;
 
  this.typeofuser=details.user_type
  this.useridofedit=details.id;
  this.getLegaldocs(this.useridofedit)
  this.getWorkexp(this.useridofedit)
  this.getCert( this.useridofedit)
  this.getEd(this.useridofedit)
  this.getPort(this.useridofedit)
  
  if(details.user_type=="Initiator")
  {
    this.initiatordisplay=false;
    this.collaboratordisplay=true;
   
  }
  else if(details.user_type=="Collaborator")
  {
    this.collaboratordisplay=false;
  }
}
//edituser methods

edituser(details)
{
  this.hidetable=true;
  this.showedituser=true;
  
  this.typeofuser=details.user_type
  this.useridofedit=details.id;
  this.getLegaldocs(this.useridofedit)
  this.getWorkexp(this.useridofedit)
  this.getCert( this.useridofedit)
  this.getEd(this.useridofedit)
  this.getPort(this.useridofedit)
 
  if(details.user_type=="Initiator")
  {
    this.initiatordisplay=false;
    this.collaboratordisplay=true;
   
  }
  else if(details.user_type=="Collaborator")
  {
    this.collaboratordisplay=false;
  }
}

showtable()
{
  this.viewusers=false;
  this.hidetable=false;
  this.showedituser=false;
}

getSkillsregion(){
  this.loginService.GetRegionSkills().subscribe(data=>
      {
        this.skillsList =JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
       
        this.filteredskillsList=this.skillsList.filter(x=>x.userid.toString()===this.userID.toString());
       
        this.filteredskillsList[0].Skillid=JSON.parse(this.filteredskillsList[0].Skillid);
        
       
      });
}
/* Retrieve skills records from the database*/
getSkills() {
this.loginService.GetSkills().subscribe(data => {
    this.skillsList2 =JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
    
    for(let i=0;i<this.filteredskillsList[0].Skillid.length;i++)
    {
    
      this.filteredskillsList2.push(this.skillsList2.filter(x=>x.id.toString()===this.filteredskillsList[0].Skillid[i].toString()));
      
    }
 
  for(var i=0;i<this.filteredskillsList2.length;i++){
    var sname=(this.filteredskillsList2[i][0]).skillname;
    this.filteredSkillsnameList.push(sname);
  }
  var AdditionalSkills=JSON.parse(this.filteredskillsList[0].AdditionalSkills);
  this.filteredSkillsnameList.push(AdditionalSkills)
 
  });
}
getLegaldocs(userId){
  this.loginService.GetLegalDocuments().subscribe(data=>
      {  
        this.documentsList =  JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
        
        this.filtereddocList=this.documentsList.filter(x=>x.userid.toString()===userId.toString());
       
      });
 
}
getLegaldocuments(){
  this.loginService.GetLegalDocuments().subscribe(data=>
      {  
      
        data = JSON.parse(data['_body']);
       
      });
 
}
getWorkexp(userId){
  this.loginService.GetWorkExperience().subscribe(data=>
      { 
        this.workList =JSON.parse(data['_body']);
       
        this.filteredworkList=this.workList.filter(x=>x.userid.toString()===userId.toString());
        
      });
}
getWorkexperience(){
  this.loginService.GetWorkExperience().subscribe(data=>
      { 
        data = JSON.parse(data['_body']);
      });
}
getEducation(){
  this.loginService.GetEducation().subscribe(data=>
      {
        data = JSON.parse(data['_body']);
      });
}
getEd(userID){
  this.loginService.GetEducation().subscribe(data=>
      {
        this.educationList =JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
        
        this.filterededucationList=this.educationList.filter(x=>x.userid.toString()===userID.toString());
       
      });
}
getCert(userID){
  this.loginService.GetCertification().subscribe(data=>
      {
        this.certificateList =JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
       
        this.filteredcertificateList=this.certificateList.filter(x=>x.userid.toString()===userID.toString());
        this.filteredcertificateList=JSON.parse(JSON.stringify(this.filteredcertificateList));
       
      });
}
getCertification(){
  this.loginService.GetCertification().subscribe(data=>
      {
        data = JSON.parse(data['_body']);
      
      });
}
getPort(userID){
  this.loginService.GetPortfolio().subscribe(data=>
      {
        this.portfolioList = JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
       
        this.filteredportfolioList=this.portfolioList.filter(x=>x.userid.toString()===userID.toString());
     
      });
}
getPortfolio(){
  this.loginService.GetPortfolio().subscribe(data=>
      {
        this.portfolioList = JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
      
        this.filteredportfolioList=this.portfolioList.filter(x=>x.userid.toString()===this.userID.toString());
       
      });
}

     //drag
     @HostListener("dragover", ["$event"]) onDragOver(event: any) {
      this.dragAreaClass = "droparea";
      event.preventDefault();
    }
    @HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
      this.dragAreaClass = "droparea";
      event.preventDefault();
    }
    @HostListener("dragend", ["$event"]) onDragEnd(event: any) {
      this.dragAreaClass = "dragarea";
      event.preventDefault();
    }
    @HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
      this.dragAreaClass = "dragarea";
      event.preventDefault();
    }
    @HostListener("drop", ["$event"]) onDrop(event: any) {
      this.dragAreaClass = "dragarea";
      event.preventDefault();
      event.stopPropagation();
      if (event.dataTransfer.files) {
        
        let files: FileList = event.dataTransfer.files;
        
        this.filename=files[0].name
        
         if(files[0].type=="application/pdf"||"application/doc")
         {
        this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,this.typeoffile);
        
        this.imageservice.ImageUplode1.subscribe(Img => this.documentpath = Img
          );
      
         }
         else if(files[0].type=="image/png"||"image/jpg"||"image/jpeg")
         {
          this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,this.typeoffile);
        
          this.imageservice.ImageUplode.subscribe((Img) => {this.documentpath = Img;
           
          });
         
          
         }
      }
    }

     saveEducation(useridd,type){
        
        if(this.collegeName===""||this.collegeName===undefined||this.educationStartDate===""||this.educationStartDate===undefined
        || this.educationEndDate===""||this.educationEndDate===undefined){
            return;
        }
        else{
        const jsonData = {
            CollegeName:this.collegeName,
            Startdate:this.educationStartDate,
            Enddate:this.educationEndDate,
            userid:useridd,
        CreatedBy:'NewUser',
        UpdatedBy:"NewUser",
        RowID:this.rowID,
       
          };
        
         this.loginService.SaveEducation(jsonData).subscribe((dataJson) => {
              
          if (dataJson['_body'].toString() === 'true') {
            if(this.type==="New"){
                // Swal.fire("saved successfully");
                this.loginService.showSuccess("Saved successfully!",'');
                   }
                   else if(this.type==="Edit")
                   {
                      //  Swal.fire("Updated successfully");
                       this.loginService.showSuccess("Updated successfully!",'');
                   }
           
          }
          this.collegeName="";
          this.educationEndDate="";
          this.educationStartDate="";
          this.getEducation();
        });
        
        this.addnewwork=false;
    }
     }

savePorfolios(useridd){
  if(this.portfolioTitle===""||this.portfolioTitle===undefined||this.portfolioDesc===""||this.portfolioDesc===undefined){
      return;
  }
  else{
 const jsonData = {
     Title:this.portfolioTitle,
     Description:this.portfolioDesc,
     userid:useridd,
 CreatedBy:'NewUser',
 UpdatedBy:'NewUser',
 RowID:this.rowID,

   };
 
  this.loginService.SavePortfolio(jsonData).subscribe((dataJson) => {
       
   if (dataJson['_body'].toString() === 'true') {
     if(this.type==="New"){
        //  Swal.fire("saved successfully");
         this.loginService.showSuccess("Saved successfully!",'');
            }
            else if(this.type==="Edit")
            {
                // Swal.fire("Updated successfully");
                this.loginService.showSuccess("Updated successfully!",'');
            }
    
   }
   this.portfolio="";
   this.portfolioTitle="";
   this.portfolioDesc="";
   this.getPortfolio();
 });
 this.addnewport=false;
 }
}

cancelport(){
  this.addnewport=false;
  this.portfolio="";
  this.portfolioTitle="";
  this.portfolioDesc="";
  this.type="New";
}

editport(row){
  this.displayportfolio=true;
  this.typeoffile="portfolio";
  
   this.type="Edit";
   this.addnewport=true;
   this.portfolioname=row.portfolioName;
 this.rowID=row.RowID;
   this.portfolio=row.Portfoliopath;
   this.portfolioTitle=row.Title;
   this.portfolioDesc=row.Description;
   this.userID=this.userID;
}

openclick(event:any)
{
 event.preventDefault();
 let element:HTMLElement=document.getElementById('uploadpic') as HTMLElement;
 element.click();
}

fileChange1(input,param) {
    
  this.imagefile = this.loginService.filechange1(input, param,this.userID);
  
  this.imageservice.ImageUplode1.subscribe(Img =>{ 
    this.ProfilePic = Img
    this.GetUsers();
 
  });
 
}

editLegaldocs(){
  this.displaylegaldocs=true;
  this.typeoffile="legaldoc";
    this.editdoc=true;
   
    this.rowID=this.filtereddocList[0].RowID;
    this.documentType=this.filtereddocList[0].TypeOfProof;
    this.legalName=this.filtereddocList[0].LegalName;
    this.country=this.filtereddocList[0].Country;
    this.city=this.filtereddocList[0].City;
    this.district=this.filtereddocList[0].DistrictTown;
    this.industry=this.filtereddocList[0].Industry;
    this.experience=this.filtereddocList[0].Experience;
    this.capitalInvestment=this.filtereddocList[0].CapitalInvestment;
    this.reference=this.filtereddocList[0].Reference;
    

}

closefile()
{
 this.displaylegaldocs=false;
 this.displaycertificates=false;
 this.displayportfolio=false;
}

saveLegaldocs(userid){
  const json={
      TypeOfProof:this.documentType,
      LegalName:this.legalName,
      Country:this.country,
      City:this.city,
      DistrictTown:this.district,
      Industry:this.industry,
      Experience:this.experience,
      CapitalInvestment:this.capitalInvestment,
      Reference:this.reference,
      DocumentName:"",
      userid:userid,
       CreatedBy:'Admin',
       UpdatedBy:'User',
       RowID:this.filtereddocList[0].RowID,
      };
      
      this.loginService.SaveLegalDocuments(json).subscribe((dataJson) => {
       
       if (dataJson['_body'].toString() === 'true') {
        
        //  Swal.fire("Updated Successfully");
        this.loginService.showSuccess("Updated successfully!",'');

          setTimeout(() => {
            //this.message = "";
          }, 5000);
         
          
     }
    // this.getLegaldocuments();
       });
       this.editdoc=false;
}

canceldocs(){
  this.editdoc=false;
}

addWork(){
  this.addnewwork=true;
  this.type="New"
 
}

saveNewwork(useridd,type){
       
  if(this.workIndustry===""||this.workIndustry===undefined||this.workExperience===""||this.workExperience===undefined||
  this.workDescription===""||this.workDescription===undefined){
      return;
  }
  else{
 const jsonData = {
     Industry:this.workIndustry,
     Experience:this.workExperience,
     Description:this.workDescription,
     userid:useridd,
 CreatedBy:'NewUser',
 UpdatedBy:'NewUser',
 RowID:this.rowID,

   };
  
  this.loginService.SaveWorkExperience(jsonData).subscribe((dataJson) => {
        
   if (dataJson['_body'].toString() === 'true') {
       if(this.type==="New"){
    // Swal.fire("saved successfully");
    this.loginService.showSuccess("Saved successfully!",'');
       }
       else if(this.type==="Edit")
       {
          //  Swal.fire("Updated successfully");
           this.loginService.showSuccess("Updated successfully!",'');
       }
    
   }
   this.workIndustry="";
   this.workExperience="";
   this.workDescription="";
   this.getWorkexperience();
 });
 this.addnewwork=false;
}
}

cancelwork(){
  this.addnewwork=false;
 
}

editWork(row){
  
  this.type="Edit";
  this.addnewwork=true;
this.rowID=row.RowID;
  this.workIndustry=row.Industry;
  this.workExperience=row.Experience;
  this.workDescription=row.Description;
  this.userID=this.userID;
}


addcert(){
  this.addnewcert=true;
 this.type="New";
}

savecert(){
        
  if(this.certificateTitle===""||this.certificateTitle===undefined||this.certificateDesc===""||this.certificateDesc===undefined){
      return;
  }
  else{
  const jsonData = {
      Certificationpath:this.certificateCopy,
      Title:this.certificateTitle,
      Description:this.certificateDesc,
      userid:this.userID,
  CreatedBy:'NewUser',
  UpdatedBy:'NewUser',
  RowID:this.rowID,
 
    };
  
   this.loginService.SaveCertification(jsonData).subscribe((dataJson) => {
        
    if (dataJson['_body'].toString() === 'true') {
      if(this.type==="New"){
          // Swal.fire("saved successfully");
          this.loginService.showSuccess("Saved successfully!",'');
             }
             else if(this.type==="Edit")
             {
                //  Swal.fire("Updated successfully");
                this.loginService.showSuccess("Updated successfully!",'');
             }
     
    }
    this.certificateTitle="";
    this.certificateDesc="";
    this.certificateCopy="";
    this.getCertification();
  });

  
  this.addnewcert=false;
  }
}

   
cancelcert(){
  this.addnewcert=false;
}

editcert(row){
  this.typeoffile="certification";
  this.displaycertificates=true;
 
   this.type="Edit";
   this.addnewcert=true;
   this.certificatename=row.certificationName;
 this.rowID=row.RowID;
   this.certificateTitle=row.Title;
   this.certificateDesc=row.Description;
   this.userID=this.userID;
}

addEd(){
  this.addnewed=true;
  this.type="New";
}

canceled(){
  this.addnewed=false;
  this.collegeName="";
   this.educationEndDate="";
   this.educationStartDate="";
}

edited(row){

  this.type="Edit";
  this.addnewed=true;
this.rowID=row.RowID;
  this.collegeName=row.CollegeName;
  this.educationStartDate=row.StartDate.toString();
  this.educationEndDate=row.EndDate.toString();
  this.userID=this.userID;
}

addPort(){
  this.addnewport=true;
  this.type="New";
}

}






